import React from 'react';
import { createSvgIcon } from '../../icon';
/* eslint-disable max-len */
export default createSvgIcon('info-outline', '0 0 96 96', React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M43.3 43.3h9.4v28.2h-9.4z" }),
    React.createElement("path", { d: "M48 1C22 1 1 22 1 48s21 47 47 47 47-21 47-47S74 1 48 1zm0 84.6c-20.7 0-37.6-16.9-37.6-37.6S27.3 10.4 48 10.4c20.7 0 37.6 16.9 37.6 37.6S68.7 85.6 48 85.6z" }),
    React.createElement("path", { d: "M43.3 24.5h9.4v9.4h-9.4z" })));
